import { Text } from "@zapier/design-system";
import styles from "./Hero.module.css";
import classNames from "classnames";
import { BackgroundSVG } from "./Components/BackgroundSVG";
import { MobileBackgroundSVG } from "./Components/MobileBackgroundSVG";

import { Container } from "../Container";
import { BreadCrumbs, BreadCrumbItem } from "../BreadCrumbs";
import { ComponentProps } from "react";
interface HeroProps {
  crumbs: BreadCrumbItem[];
  description?: string;
  title: string;
  titleTag?: ComponentProps<typeof Text>["tag"];
}

export const Hero = ({ crumbs, description, title, titleTag }: HeroProps) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapperWithDescription]: !!description,
      })}
    >
      <BackgroundSVG className={styles.backgroundImage} />
      <MobileBackgroundSVG className={styles.mobileBackgroundImage} />
      <Container className={styles.container}>
        <div className={styles.breadCrumbsWrapper}>
          {crumbs.length > 1 && <BreadCrumbs crumbs={crumbs} />}
        </div>
        <div className={styles.textContent}>
          <div>
            <div className={styles.title}>
              <Text data-id="title" type="PageHeader" tag={titleTag}>
                {title}
              </Text>
            </div>
          </div>
          {description ? (
            <div className={styles.description}>
              <Text type="Body1">{description}</Text>
            </div>
          ) : null}
        </div>
      </Container>
    </div>
  );
};
